module.exports = __webpack_public_path__ + "static/media/14UNEP12.eb25e435.jpg";